import constants from '../../constants/constant';

// Whether a client gets Vendor Performance and Top Sellers automatically (mirrors
// Client::getsVendorTopSellersReports). Matched by POS id; Shopify Pilot also keeps its
// historical name match. Other POS are matched by id only: a name match on 'lightspeed' or
// 'heartland' would also catch legacy Lightspeed (1113) and legacy Heartland (1140), which aren't supported.
export function getsVendorTopSellersReports(client) {
    const clientObj = client || {};
    const posId = Number(clientObj.PointOfSaleId ?? clientObj.pointOfSaleId ?? clientObj.point_of_sale_id);
    const posName = String(clientObj.PointOfSaleName || clientObj.pointOfSaleName || clientObj.pointOfSale?.name || clientObj.pointOfSale?.Name || '').toLowerCase();

    if (constants.VENDOR_TOP_SELLERS_POS_IDS.includes(posId)) {
        return true;
    }

    return posName.includes('shopify') || posName.includes('pilot');
}
